export const Role = {
  ADMIN: 'admin',
  USER: 'user',
}
export const hasRole = (user, roles) => user && user.data && roles && roles.indexOf(user.data.role) !== -1;